export const EBM_RESOURCE_CONFIG_FIELD_KEYS = {
  configuration: 'ebm.resourceConfiguration',
} as const;

export const EBM_RESOURCE_CONFIG_FIELD_KEY_LIST = [EBM_RESOURCE_CONFIG_FIELD_KEYS.configuration] as const;

/** optionMeta 中弹性裸金属节点计价元数据固定 key */
export const EBM_RESOURCE_CONFIG_OPTION_META_KEYS = {
  ebmNode: 'ebmNode',
} as const;
